import { AddressDisplayModelFormGroup } from './../../../../api/models/ace/xFound/Portal/Core/CAQ/Models/address-display-model';
import { Component, Input, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { EMPTY, Observable, of } from 'rxjs';
import { PostleitzahlzuordnungDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/postleitzahlzuordnung-display-model';
import { PostleitzahlzuordnungService } from '@/api/service-index';
import { switchMap } from 'rxjs/operators';
import { StammdatenService } from '@/core/services/stammdaten.service';
import { StateService } from '@/core/services/state.service';

@Component({
  selector: 'address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})
export class AddressComponent implements OnInit {
  bundeslaenderItems: string[];

  @Input("form")
  public addressForm: AddressDisplayModelFormGroup;

  public postleitzahlzuordnungen: Observable<PostleitzahlzuordnungDisplayModel[] | null | undefined>;

  public postleitzahlzuordnungFilterChange(name: string): void {
    if (name?.length >= 3) {
      if (name)
        this.postleitzahlzuordnungen = this.plzzuordnungService.apiPostleitzahlzuordnungGetPostleitzahlzuordnungByNameGet({ Name: name }).pipe(switchMap(response => of(response.postleitzahlzuordnungen)));
      else
        this.postleitzahlzuordnungen = EMPTY;
    }
  }

  public postleitzahlzuordnungValueChange(evt: string): void {
    if (evt) {
      this.postleitzahlzuordnungen.subscribe(res => {
        if (res == null)
          return;

        var zuordnung = res.find(element => element.id == evt);
        if (zuordnung == null)
          return;

        this.addressForm.Postalcode.setValue(zuordnung.postleitzahl);
        this.addressForm.City.setValue(zuordnung.ort);
        this.addressForm.Bundesland.setValue(zuordnung.bundesland);
      });
    }
  }

  constructor(protected plzzuordnungService: PostleitzahlzuordnungService, protected stammdatenService: StammdatenService, protected stateService: StateService) {

  }

  ngOnInit(): void {
    this.stammdatenService.GetBundeslaender().subscribe(bundeslaender => {
      if (bundeslaender)
        this.bundeslaenderItems = bundeslaender;
    });

    if (this.stateService.IsEndvalidationEnabled) {
      this.addressForm.Street.addValidators(Validators.required);
      this.addressForm.City.addValidators(Validators.required);
      this.addressForm.Postalcode.addValidators(Validators.required);
      this.addressForm.markAllAsTouched();
    }
  }
}
